<template>
    <v-row class="py-6">
        <v-col cols="auto">
            <v-btn @click="print" outlined class="gray--text">
                <v-icon class="mr-2">print</v-icon>
                <div>
                    Распечатать
                </div>
            </v-btn>
        </v-col>
    </v-row>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: 'ActionButtons',
    data: () => ({
        dialog: false
    }),
    props: {
        selected: {
            required: true
        }
    },
    computed: {},
    methods: {
        ...mapActions('base', ['showMessage']),
        closeDialog() {
            this.dialog = false;
        },
        print() {
            if (!this.selected.length) {
                this.showMessage({ message: 'Выберите хотя бы одну позицию', color: 'error' });
                return;
            }
            this.$emit('print');
        }
    }
};
</script>

<style scoped></style>
